import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { HolidayDto } from '../../../commonTypes/organization.types';

const useHttpGetHolidaysByBranchOnMount = (branchId?: string | null) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<HolidayDto[]>([]);

    const exec = () => {
        const { exec, abort } = organizationApi.getHolidaysByBranch({
            params: {
                branchId,
            },
            onSuccess: res => {
                setData(res.body);
            },
            onError: err => console.log(err),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(() => {
        exec();
    }, []);

    return { isReady, data };
};

export default useHttpGetHolidaysByBranchOnMount;
